import React from 'react';
import { observer } from 'mobx-react';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import {
  DiscountDto, PopulatedCampaignUserDto, PopulatedCampaignUserDtoStatusEnum,
} from '@coretava/api/ecommerce-service';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { Box, CircularProgress } from '@mui/material';
import Spin from './Spin';
import { Steps } from './types';
import Congratulations from './Congratulations';

const WheelPopup: React.FC<{ campaignUser: PopulatedCampaignUserDto, openSignup: () => void }> = ({
  campaignUser,
  openSignup,
}) => {
  const [discount, setDiscount] = React.useState<DiscountDto>();
  const [step, setStep] = React.useState<Steps>('spin');

  React.useEffect(() => {
    if (campaignUser.discount) {
      void DiscountsStore.api
        .discountsControllerGet(AppStore.app.id, campaignUser.discount.id)
        .then((d) => setDiscount(d.data.discount));
    }
  }, [campaignUser]);

  React.useEffect(() => {
    if (campaignUser.discount) {
      setStep('congratulations');
    }
  }, [campaignUser]);

  return React.useMemo(() => {
    switch (true) {
      case campaignUser.status === PopulatedCampaignUserDtoStatusEnum.Pending:
        return <Spin onDone={() => CampaignUserStore.fetchCampaignUsers()} openSignup={openSignup} />;
      case !discount:
        return (
          <Box
            width={350}
            height={200}
            display="flex"
            alignItems="center"
            justifyContent="center"
            overflow="hidden"
          >
            <CircularProgress color="primary" />
          </Box>
        );
      case step === 'congratulations':
        return <Congratulations discount={discount} />;
      default:
        return undefined;
    }
  }, [step, discount]);
};

export default observer(WheelPopup);
